import React from "react"
import Img from "gatsby-image"

const Schedule = ({ data, image }) => {
  return (
    <React.Fragment>
      <div className="d-flex flex-column flex-md-row flex-lg-row pb-5 pb-sm-5 py-md-5 py-lg-5 brand-background">
        <Img
          style={{
            minHeight: "15rem",
            minWidth: "50vw",
            objectFit: "Cover",
          }}
          className="shadow-lg "
          fluid={image.acf.photo_featurette.localFile.childImageSharp.fluid}
          alt={image.acf.photo_featurette.alt_text}
        />
        <div className="d-flex flex-column mx-auto mt-5 mt-md-0 mt-lg-0 text-white">
          <h2 className="text-center m-0">Jadwal Klinik</h2>
          <dl className="row mx-auto my-0">
            {data.map(schedule => {
              if (!schedule.node.acf.is_clinic_opened)
                return (
                  <React.Fragment key={schedule.node.id}>
                    <dt key={schedule.node.id} className="text-right col-6">
                      {schedule.node.title}
                    </dt>
                    <dd className="col-6">Libur</dd>
                  </React.Fragment>
                )
              return (
                <React.Fragment key={schedule.node.id}>
                  <dt key={schedule.node.id} className="text-right col-6">
                    {schedule.node.title}
                  </dt>
                  <dd className="col-6">
                    {schedule.node.acf.open_at} - {schedule.node.acf.close_at}
                  </dd>
                </React.Fragment>
              )
            })}
          </dl>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Schedule
